module.exports = require("lodash/core");